import {TENANT_WESTERN, TENANT_NATION} from '@/utils/tenant';

// The entity a login on this site asks studx-authen for. One build serves both
// universities and they are told apart by hostname, using the same substring
// rule as tenant.js. Any other host (localhost, an IP) sends nothing, and authen
// uses the user's primary entity.
export function loginEntityFromHostname(hostname) {
  const value = typeof hostname === 'string' ? hostname : '';
  if (value.includes(TENANT_WESTERN)) return 'x-studi-western';
  if (value.includes(TENANT_NATION)) return 'x-studi-nation';
  return undefined;
}
